import { IReactNodeViewContext } from 'common/Prose/nodeViews/ReactNodeView/ReactNodeViewContext'
import { SmartLinkAttributes, SmartLinkDataAttributes } from 'common/Prose/utils/smartLinks/types'
import { MouseEvent } from 'react'
import { ArticleSmartLink } from './ArticleSmartLink'
import { FolderSmartLink } from './FolderSmartLink'
import { HandbookSmartLink } from './HandbookSmartLink'
import { UserSmartLink } from './UserSmartLink'

type EditableSmartLinkProps = {
  sanitizedHTML: { __html: string }
  nodeViewContext: Partial<IReactNodeViewContext>
  dataProps: SmartLinkDataAttributes
  displayTitle: string
  getPos: () => number
  handleLinkClick: (event: MouseEvent<HTMLAnchorElement>) => void
  parentRef: React.RefObject<HTMLSpanElement>
  isUserSidebarOpen: boolean
  setIsUserSidebarOpen: (isOpen: boolean) => void
  showMentionFormatBar: boolean
  setShowMentionFormatBar: (showMentionFormatBar: boolean) => void
}

export type EditableSmartLinkChildProps = EditableSmartLinkProps

export const EditableSmartLink = (props: EditableSmartLinkProps) => {
  const { nodeViewContext } = props
  const { node } = nodeViewContext as IReactNodeViewContext
  const attrs = node.attrs
  const { type } = attrs as SmartLinkAttributes

  return (
    <>
      {type === 'Article' && <ArticleSmartLink {...props} />}
      {type === 'Handbook' && <HandbookSmartLink {...props} />}
      {type === 'Folder' && <FolderSmartLink {...props} />}
      {type === 'User' && <UserSmartLink {...props} />}
    </>
  )
}
